import React from 'react';
import Formsy from 'formsy-react';
import SellerStripeForm from '../SellerSignup/SellerStripeForm';
import next from '../../assets/images/newui/sellersignup/next-btn.svg'
import ErrorBox from '../SellerSignup/ErrorBox';
import essentialImg from '../../assets/images/newui/sellersignup/essential.svg'
import premiumImg from '../../assets/images/newui/sellersignup/premium.svg'
import ultimateImg from '../../assets/images/newui/sellersignup/ultimate.svg'
import { Modal, Dimmer, Loader } from 'semantic-ui-react';
import DisclaimerSection from '../DisclaimerSection/DisclaimerSection';
import './ChangePaymentMethod.less'

const initialState = {
    render: false,
    loading: false
}

class ChangePaymentMethodModal extends React.Component {

    constructor(props){
        super(props);
        this.state = initialState;
    }
    getImage = (type) => {
        switch (type) {
            case 'Essential':
                return essentialImg;
            case 'Premium':
                return premiumImg;
            case 'Ultimate':
                return ultimateImg;
            default:
                return premiumImg;
        }
    }

    componentDidMount(){
        this.setState({ render: true });
    }


    render() {
        const { open, onClose, processPaymentChange, stripe, elements, onCardFormToggle, paymentMethods, setSelectedPaymentMethod, error, isCardFormVisible, selectedPaymentMethod, setCard } = this.props;
        return this.state.render && <Modal open={open} onClose={onClose} className='payment-change-modal'>
            <Modal.Content>
            {this.props.loading ? <Dimmer className='pending-payment-loader-dimmer' active>
                                <Loader indeterminate size='massive' />
                            </Dimmer> : ''}
                <Formsy onValidSubmit={this.props.processPaymentChange}>
                    {isCardFormVisible ?
                        <div className='payment-change-modal-card-form'>
                            <SellerStripeForm onExistingCardsClick={(e) => onCardFormToggle(e, false)} areCardsExists={false} onChange={({ card }) => setCard(card)} stripe={stripe} elements={elements}  hideDisclaimer={true} buttonText='PAY NOW' />
                        </div>
                        : <div className='payment-change-modal-existing-card-container'>
                            {/*<div className='subscription-container-card-existing'>
                                <div className='subscription-container-card-existing-header'>
                                    Existing Cards
                                    <img src={exCards} className='payment-change-modal-existing-card-img' />
                                    <div className='subscription-container-card-btn-container'>
                                        <button className='subscription-container-card-btn' onClick={(e) => onCardFormToggle(e, true)}><span>+</span> Add New Card <img src={next} /> </button>
                                    </div>
                                </div>
                                {paymentMethods.map(pm =>
                                    <div className='payment-change-modal-existing-card' onClick={() => setSelectedPaymentMethod(pm)}><PaymentCard {...pm.card} isSelected={selectedPaymentMethod.id == pm.id} /></div>
                                )}
                                </div>*/}
                            <DisclaimerSection buttonText='PAY NOW' />
                        </div>}
                    {/*this.props.setIsDefaultCard && <Checkbox className='payment-change-modal-default-card' label='Use this card for all future payments' onChange={(e, data) => this.props.setIsDefaultCard(data.checked)} checked={this.props.isDefaultCard} />*/}
                    {error && <ErrorBox message={error} />}
                    <button className='payment-change-modal-submit' type='submit'> PAY NOW <img src={next} /></button>
                </Formsy>
            </Modal.Content>
        </Modal>
    }
}
export default ChangePaymentMethodModal;